import React from 'react';
import { Button } from 'antd';
import { MessageOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

// Reuse the canonical-ID entry point consumed by useChatEntryPoints. Never
// resolve the form's phone number: the sender can be a different customer.
export function WebsiteConversationLink({ conversationId, onOpen }) {
  const navigate = useNavigate();
  if (typeof conversationId !== 'string' || !conversationId.startsWith('con_')) return null;
  return <Button aria-label="Open WhatsApp chat" type="link" size="small" icon={<MessageOutlined />}
    style={{ padding: 0, height: 'auto', fontSize: 12 }}
    onClick={() => {
      navigate('/querysetv4', { state: { openChatId: conversationId } });
      onOpen?.();
    }}>Open WhatsApp chat</Button>;
}
